import { Component } from '@angular/core';

import { config } from './../../../../../config/index';

@Component({
  selector: 'copyright-footer',
  template: require('./copyright-footer.component.html'),
  styles: [require('./copyright-footer.component.less')],
  preserveWhitespaces: true
})

export class CopyrightFooterComponent {

  termsOfUseUrl: string = config.termsOfUseUrl;
  privacypolicyUrl: string = config.termsOfUseUrl;
  orthoCatapultUrl: string = config.orthoCatapultUrl;

  constructor() { }

  openNewTab(option: any) {
    if (option === 'privacy') {
      window.open(this.privacypolicyUrl, '_blank', '');
    } else if (option === 'terms') {
      window.open(this.termsOfUseUrl, '_blank', '');
    } else if (option === 'ortho') {
      window.open(this.orthoCatapultUrl, '_blank', '');
    }
  }
}